import { useMutation } from "react-query";
import { getIsAdmin } from "../../../actions/Helper";
//Fetching Carrier Contact

const useGetIsAdmin = () => {
  return useMutation(getIsAdmin);
};
export default useGetIsAdmin;
